import { Component, OnInit } from "@angular/core";
import { registerLocaleData } from '@angular/common';
import localeKa from '@angular/common/locales/ka';
import localeRu from '@angular/common/locales/ru';
import { TranslateService } from "@ngx-translate/core";
import { finalize } from 'rxjs/operators';

import { AuthService } from "./shared/auth/auth.service";
import { Utils } from "./models/general/utils";
import { NavigatorService } from "./shared/services/navigator.service";
import { LoadingService } from './shared/services/loading.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {
  loading = false;
  bootLoading = true;

  constructor(
    private auth: AuthService,
    private navigator: NavigatorService,
    private translate: TranslateService,
    private pageLoading: LoadingService
  ) {
    registerLocaleData(localeKa, 'ka');
    registerLocaleData(localeRu, 'ru');
    this.translate.setDefaultLang(Utils.getLanguage());
    this.translate.use(Utils.getLanguage());
    this.pageLoading.loading$.subscribe((count) => {
      this.loading = count > 0;
    });
  }

  ngOnInit() {
    this.auth.validate().pipe(
      finalize(() => {
        this.bootLoading = false;
      })
    ).subscribe((result) => {
      if (!result) {
        this.navigator.toLogin();
      }
    });
  }
}
